import * as React from 'react';
import { ControlLabel, FormControl, Form, FormGroup } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import Editor from '../../components/common/editor/Editor';
import CheckboxInput from '../../components/common/CheckboxInput';

interface ITemplate {
    id?: number;
    language: string;
    subject?: string;
    content: string;
    url: string;
    includeSubject: boolean;
    isSms: boolean;
    isIFrame: boolean;
    iFrameUrl: string;
    templateType: string;
}

interface IFile {
    reference: any;
    filename: string;
}

interface ITags {
    tags: string;
}

interface ITemplateFormProps {
    template: ITemplate;
    files: IFile[];
    tags: ITags[];
    index: number;
    onChange: (e: any) => void;
    onEditorChange: (content: string, index: number) => void;
    onImageUploaded: (reference: string, filename: string) => void;
    onIFrameUrlChange: (e: any) => void;
    onIsIframeChange: (checked: boolean) => void;
}

function renderContentArea(props: ITemplateFormProps) {
    let component = null;
    if (props.template.isSms) {
        component = (
            <FormGroup>
                <FormControl
                    type="textarea"
                    name="content"
                    value={props.template.content ? props.template.content : ''}
                    onChange={props.onChange}
                />
            </FormGroup>
        );
    } else if (props.template.isIFrame) {
        component = (
            <FormGroup>
                <ControlLabel>{Translate('link')}</ControlLabel>
                <FormControl
                    type="input"
                    name="url"
                    value={props.template.iFrameUrl}
                    onChange={props.onIFrameUrlChange}
                />
                <iframe className="template-iframe-editor" src={props.template.iFrameUrl}></iframe>
            </FormGroup>
        );
    } else {
        component = (
            <FormGroup>
                <Editor
                    onChange={(content: string) => props.onEditorChange(content, props.index)}
                    content={props.template.content ? props.template.content : ''}
                    height={500}
                    files={props.files}
                    onImageUploaded={props.onImageUploaded}
                    addImageModal={true}
                />
            </FormGroup>
        );
    }

    let checkbox =
        props.template.templateType == 'System' ? (
            <CheckboxInput
                checked={props.template.isIFrame}
                name="isIFrame"
                label={Translate('templates/modal/external-page')}
                onChange={(e: any) => {
                    props.onIsIframeChange(e.target.checked);
                }}
            />
        ) : null;

    return (
        <Form>
            <FormGroup className="template-form">
                {checkbox}
                {component}
            </FormGroup>
        </Form>
    );
}

function renderWithTemplateTags(props: ITemplateFormProps) {
    let DoubleCurlyBracesLeft = '{{';
    let DoubleCurlyBracesRight = '}}';
    return (
        <div>
            <div className="col-md-9">{renderContentArea(props)}</div>
            <div className="col-md-3">
                <ControlLabel>
                    {props.tags.length} {Translate('templates/modal/available-parameters')}:
                </ControlLabel>
                <div className="template-parameters">
                    <ul className="template-parameters-ul">
                        {props.tags.map((tag) => (
                            <li key={tag as any as string} className="template-parameters-ul-li">
                                {DoubleCurlyBracesLeft}
                                {tag}
                                {DoubleCurlyBracesRight}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

const TemplateForm = (props: ITemplateFormProps) => {
    return (
        <div className="col-md-12">
            <br />
            {props.template.includeSubject && (
                <div className="template-subject col-md-12">
                    <ControlLabel>{Translate('templates/modal/subject')}</ControlLabel>
                    <FormControl
                        type="text"
                        name="subject"
                        value={props.template.subject ? props.template.subject : ''}
                        onChange={props.onChange}
                    />
                </div>
            )}
            {props.tags.length === 0 ? (
                <div className="col-md-12">{renderContentArea(props)}</div>
            ) : (
                <div>{renderWithTemplateTags(props)}</div>
            )}
        </div>
    );
};

export default TemplateForm;
